export enum TseExportStates {
  COMPLETED = 'COMPLETED',
}
